import { Link } from "react-router-dom/cjs/react-router-dom.min"
import { APP_DIRECTORY } from "../SystemVariables"


const LogoutArea = (props) => {
    if(props.accessToken !== undefined) {
        return <Link to={`${APP_DIRECTORY}/logout`}>Log out</Link>
    } else {
        return <div></div>
    }
}

export default LogoutArea
